import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { motion } from 'framer-motion'
import styled from 'styled-components'

const StCheckboxContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  margin-left: 1px;
  margin-top: 3px;
  flex-grow: 0;
`

const StCheckbox = styled.input`
  ${({ theme }) => `
    border: 1px solid ${theme.Colors.Neutrals.Darkest};
    border-radius: ${theme.UI.BorderRadius.Small}px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    appearance: none;
    background-color: transparent;

    &:checked {
      background-color: ${theme.Colors.Theme.Primary};
      border-color: ${theme.Colors.Theme.Primary};
    }
  `}
`

const StLabel = styled.label`
  ${({ theme }) => theme.Typography.BodyLargeRegular};
  width: '100%';
  color: ${({ theme }) => theme.Components.Conversational.Text};

  font-weight: 400;
`

const StIcon = styled(FontAwesomeIcon)`
  position: absolute;
  width: 12px;
  height: 12px;
  top: 2px;
  left: 2px;
  bottom: 2px;
  right: 2px;
  z-index: 1;
  pointer-events: none;
`

const AnimatedStIcon = motion(StIcon)

export { AnimatedStIcon, StCheckbox, StCheckboxContainer, StLabel }
